export const dateDef = {
  // $id: "/schemas/dateDef",
  oneOf: [{ type: "string", format: "date-time" }, { instanceof: "Date" }]
};


export const ByAtSchema = {
  type: "object",
  properties: {
    by: { type: "string" },
    at: dateDef,
    atms: {
      type: "integer"
    }
  },
  required: ["by", "at"],
};

export const AmountSchema = {
  type: "object",
  properties: {
    value: {
      type: "number",
      default: 0
    },
    currency: {
      type: "string"
    },
    rate: {
      type: "number"
    },
    currencyDate: dateDef
  },
  required: ["value", "currency"]
};

export const RegExAccountId = "^[SCP]{1}[0-9]{5,6}$";
export const RegExId6 =
  "^[23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz]{6}$";
export const RegExId =
  "^[23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz]{17}$";
export const RegExLocodeId = "^[A-Z]{2}[A-Z0-9]{3}$";

// todo: remove the regex defs above
export const RegEx = {
  id: /^[23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz]{17}$/,
  Id6: /^[23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz]{6}$/,
  AccountId: /^[SCP]{1}[0-9]{5,6}$/,
  ShipperId: /^S[0-9]{5,6}$/,
  CarrierId: /^C[0-9]{5,6}$/,
  ProviderId: /^P[0-9]{5,6}$/,
  LocodeId: /^[A-Z]{2}[A-Z0-9]{3}$/,
  Email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,

  // Like Email but requires the TLD (.com, etc)
  EmailWithTLD: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  Url: /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i
};

export const locodeDef = {
  $id: "/schemas/locodeDef",
  type: "string",
  pattern: RegExLocodeId
};

export const idDef = {
  description: "Regex for mongo string id field",
  type: "string",
  pattern: RegEx.id.source
};
export const accountIdDef = {
  type: "string",
  pattern: RegExAccountId
};



export const rootSchema = {
  type: "object",
  properties: {
    _id: { type: "string" }
  }
}